import React from "react";
import "../css/Gallery.css";

const Gallery = () => {
  return (
    <div className="gallery7">

      {/* ================= HERO ================= */}
      <section className="g7-hero">
        <h1>Inside PULSE</h1>
        <p>Training floors, raw moments, real intensity.</p>
      </section>


      {/* ================= FEATURED STRIP ================= */}
      <section className="g7-featured">
        <img
          src="https://images.pexels.com/photos/1552249/pexels-photo-1552249.jpeg"
          alt="featured gym"
        />
        <div className="g7-featured-text">
          <h2>Where Work Gets Done</h2>
          <p>
            Every space is designed for movement, focus, and performance —
            nothing extra.
          </p>
        </div>
      </section>


      {/* ================= MAIN GALLERY GRID ================= */}
      <section className="g7-grid">

        <img src="https://images.pexels.com/photos/841130/pexels-photo-841130.jpeg" alt="gym" />
        <img src="https://images.pexels.com/photos/1954524/pexels-photo-1954524.jpeg" alt="training" />
        <img src="https://images.pexels.com/photos/3823039/pexels-photo-3823039.jpeg" alt="workout" />
        <img src="https://images.pexels.com/photos/1552249/pexels-photo-1552249.jpeg" alt="weights" />

        <img src="https://images.pexels.com/photos/6453399/pexels-photo-6453399.jpeg" alt="coach" />
        <img src="https://images.pexels.com/photos/3757376/pexels-photo-3757376.jpeg" alt="strength" />

        <img src="https://images.pexels.com/photos/1552249/pexels-photo-1552249.jpeg" alt="gym vibe" />
        <img src="https://images.pexels.com/photos/3823063/pexels-photo-3823063.jpeg" alt="conditioning" />
        <img src="https://images.pexels.com/photos/4327033/pexels-photo-4327033.jpeg" alt="movement" />
        <img src="https://images.pexels.com/photos/841130/pexels-photo-841130.jpeg" alt="strength zone" />

      </section>


      {/* ================= CLOSING ================= */}
      <section className="g7-end">
        <h2>Real Training. No Filters.</h2>
      </section>

    </div>
  );
};

export default Gallery;
